import { Dialog, Transition } from "@headlessui/react";
import { ZuClose } from "components/icons";
import { Fragment } from "react";

import type { ReactNode } from "react";

interface calendarModalProps {
  title?: string;
  content: ReactNode;
  isOpen: boolean;
  closeModal: Function;
}

const CalendarModal = ({
  content,
  title,
  isOpen,
  closeModal,
  ...otherProps
}: calendarModalProps) => {
  return (
    <Transition appear show={isOpen} as={Fragment} {...otherProps}>
      <Dialog as="div" className="relative z-10" onClose={() => closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-2xl bg-white text-left align-middle shadow-xl transition-all">
                <div className="flex justify-between bg-[#FAFAFA] py-3 px-6 border-b border-[#DADAE7]">
                  <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-[#48484A]">
                    {title}
                  </Dialog.Title>
                  <ZuClose
                    size={12}
                    onClick={() => closeModal}
                    className="text-green cursor-pointer mt-2"
                  />
                </div>

                <div className="px-6">{content}</div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default CalendarModal;
